





























































































import Vue from 'vue';
import { setGtmClass } from '../lib/utilities/gtmClass';

export default Vue.extend({
  name: 'Dialog',
  inheritAttrs: false,

  props: {
    showHeader: { type: Boolean, default: true },
    showBody: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: false },
    showConfettiBackground: { type: Boolean, default: false },
    approveName: String,
    approveButtonClass: String,
    approveButtonColor: String,
    approveButtonOutlined: Boolean,
    approveButtonText: Boolean,
    approveButtonDisabled: Boolean,
    approveButtonLoading: Boolean,
    approveButtonProgress: Boolean,
    body: String,
    footer: String,
    cancelName: String,
    cancelButtonClass: String,
    cancelButtonColor: String,
    cancelButtonDisabled: Boolean,
    cancelButtonOutlined: Boolean,
    cancelButtonText: Boolean,
    dialogClass: String,
    cardClass: String,
    header: String,
    maxWidth: { type: String, required: true },
    height: { type: String, default: 'auto' },
    persistent: { type: Boolean, default: true },
    value: { type: [String, Boolean] },
    approveButtonGtmClass: String,
    bodyCardClass: String
  },

  computed: {
    approveClass() {
      return this.approveButtonClass ?? ['primary', 'ml-6'];
    },

    cancelClass() {
      return this.cancelButtonClass ?? ['normal-button', 'smart-medium-grey'];
    },

    contentClass() {
      return ['b-shadow-1', this.dialogClass].join(' ');
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.update(val);
      }
    }
  },
  watch: {
    dialog: {
      async handler() {
        await Vue.nextTick();
        setGtmClass(this.approveButtonGtmClass);
      },
      immediate: true
    }
  },
  methods: {
    update(val) {
      this.$emit('input', val);
    }
  }
});
